import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    ILoadGuestServiceIdAction,
    ILoadGuestServiceIdSuccessAction,
    ILoadGuestServiceIdErrorAction
} from '../../actions/guest/service-id';
import { ITicketsState } from '@telstra-connect/tickets/state';
import { initialState } from '../initial-state';

export type GuestServiceIdAction
    = ILoadGuestServiceIdAction
    | ILoadGuestServiceIdSuccessAction
    | ILoadGuestServiceIdErrorAction;

const init = (state: ITicketsState, action: GuestServiceIdAction) => ({
    ...state,
    guestServiceIdRequest: {
        ...initialState.guestServiceIdRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: GuestServiceIdAction) => ({
    ...state,
    guestServiceIdRequest: {
        ...initialState.guestServiceIdRequest,
        status: action.status,
        data: (action as ILoadGuestServiceIdSuccessAction).data
    }
});

const failure = (state: ITicketsState, action: GuestServiceIdAction) => ({
    ...state,
    guestServiceIdRequest: {
        ...initialState.guestServiceIdRequest,
        status: action.status,
        error: (action as ILoadGuestServiceIdErrorAction).error
    }
});

export const guestServiceIdReducer = createAsyncReducer(initialState, init, success, failure);
